<div class="quick-search-header">
<mat-form-field appearance="outline" class="ml-2">
    <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchTextInput()" matInput
           [matAutocomplete]="auto"
           placeholder="Search Cases">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onResultClick($event.option.value)">
        <ng-container *ngIf="searchText">
            <ng-container *ngIf="searching; else results">
                <mat-option>Searching...</mat-option>
            </ng-container>
            <ng-template #results>
                <ng-container *ngIf="cases?.length !== 0; else noResults">
                    <ng-container *ngFor="let case of cases">
                        <mat-option [value]="case">
                            {{case.firstName + ' ' + case.lastName}}
                            <span class="search-result-subtext">
                            {{case.caseNumber}}
                            </span>
                        </mat-option>
                    </ng-container>
                </ng-container>
                <ng-template #noResults>
                    <mat-option>
                        No results found.
                    </mat-option>
                </ng-template>
            </ng-template>
        </ng-container>
    </mat-autocomplete>
    <button type="button" mat-icon-button matSuffix>
        <mat-icon>search</mat-icon>
    </button>
</mat-form-field>
</div>
